module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"users":{"show":{"meta_tags":{"description":"%{name} ist bei CAPinside. Werden auch Sie Teil einer neuen Investmentkultur. Kostenfrei anmelden - Über 25.000 Investment-Profis."}}}}}}}')
  delete Component.options._Ctor
}
